'use client';
import cookieUtil from '@/intl-jdi-common-ssr/utils/cookieUtils';
import { useEffect } from 'react';
import { fingerPrintCookieKey } from '@/utils/fingerprint';

const FingerPrint = () => {
  useEffect(() => {
    try {
      getJsToken(function (res: any) {
        const { jsToken } = res;
        cookieUtil.setCookie(fingerPrintCookieKey, jsToken, 365);
      }, 3000);
    } catch (error) {
      console.log(error);
    }
  }, []);
  return <></>;
};

export default FingerPrint;
